'use strict';

// DO NOT INCLUDE base.js becuse it is included in cart.js (issue: double product in cart when user clicks on "add to cart" in productDetails.isml)
// var base = require('BASE/product/base');

function scalapayShadowRootStyle() {
    const hostElements = document.querySelectorAll('.scalapay-widget-sm scalapay-widget');
    const styleContent = document.createElement('style');
    const styleLogo = document.createElement('style');

    styleContent.innerHTML = `
        .sp-pay-installment {
            justify-content: end;
        }

        .sp-pay-installment span:first-child {
            text-align: end;
        }`;
        
    styleLogo.innerHTML = `
        svg {
            width: 77px;
        }`;

    hostElements.forEach(hostElement => {
        if (hostElement.shadowRoot) {
            const host2Elements = hostElement.shadowRoot.querySelectorAll('scalapay-pay-installments');

            host2Elements.forEach(host2Element => {
                if (host2Element.shadowRoot) {
                    host2Element.shadowRoot.appendChild(styleContent.cloneNode(true));

                    const host3Elements = host2Element.shadowRoot.querySelectorAll('scalapay-logo');

                    host3Elements.forEach(host3Element => {
                        if (host3Element.shadowRoot)
                            host3Element.shadowRoot.appendChild(styleLogo.cloneNode(true));
                    });
                }
            });
        }
    });
}

const interval = setInterval(() => {
    const exists = document.querySelector('.scalapay-widget-sm scalapay-widget');

    if (exists && exists.shadowRoot.innerHTML != '') {
        scalapayShadowRootStyle();
        clearInterval(interval);
    }
}, 100);



module.exports = {
  changeVariationRadio: function() {
    $(document).on('change', '.js-radio-option', function(e) {
      e.preventDefault();

      var $productContainer = $(this).closest('.set-item');
      if (!$productContainer.length) {
        $productContainer = $(this).closest('.product-detail');
      }

      var value = $(this).data('attr-value');
      var pid = $productContainer.data('pid') || '';

      pid = pid.slice(0, -1) + value;
      if (!pid) {
        console.warn('!! cannot get PID from radio button !!');
      }
      $productContainer.data('pid', pid);
    });
  },

  updateAttributesAndDetails: function() {
    $('body').on('product:statusUpdate', function(e, data) {
      var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

      $productContainer
        .find('.description-and-detail .product-attributes')
        .empty()
        .html(data.attributesHtml);

      if (data.shortDescription) {
        $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
        $productContainer
          .find('.description-and-detail .description .content')
          .empty()
          .html(data.shortDescription);
      } else {
        $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
      }

      if (data.longDescription) {
        $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
        $productContainer
          .find('.description-and-detail .details .content')
          .empty()
          .html(data.longDescription);
      } else {
        $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
      }
    });
  },

  showSpinner: function() {
    $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function() {
      $.spinner().start();
    });
  },
  updateAttribute: function() {
    $('body').on('product:afterAttributeSelect', function(e, response) {
      if ($('.product-detail>.bundle-items').length) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else if ($('.product-set-detail').eq(0)) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else {
        $('.product-id').text(response.data.product.id);
        $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
      }
    });
  },
  updateAddToCart: function() {
    $('body').on('product:updateAddToCart', function(e, response) {
      // update local add to cart (for sets)
      $('button.add-to-cart', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);

      var enable = $('.product-availability')
        .toArray()
        .every(function(item) {
          return $(item).data('available') && $(item).data('ready-to-order');
        });
      $('button.add-to-cart-global').attr('disabled', !enable);
    });
  },
  updateAvailability: function() {
    $('body').on('product:updateAvailability', function(e, response) {
      $('div.availability', response.$productContainer)
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available);

      $('.availability-msg', response.$productContainer)
        .empty()
        .html(response.message);

      if ($('.global-availability').length) {
        var allAvailable = $('.product-availability')
          .toArray()
          .every(function(item) {
            return $(item).data('available');
          });

        var allReady = $('.product-availability')
          .toArray()
          .every(function(item) {
            return $(item).data('ready-to-order');
          });

        $('.global-availability')
          .data('ready-to-order', allReady)
          .data('available', allAvailable);

        $('.global-availability .availability-msg')
          .empty()
          .html(allReady ? response.message : response.resources.info_selectforstock);
      }
    });
  },
  sizeChart: function() {
    $('.size-chart a').on('click', function(e) {
      e.preventDefault();
      var url = $(this).attr('href');
      var $prodSizeChart = $(this)
        .closest('.size-chart')
        .find('.size-chart-collapsible');
      if ($prodSizeChart.is(':empty')) {
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          success: function(data) {
            $prodSizeChart.append(data.content);
          }
        });
      }
      $prodSizeChart.toggleClass('active');
    });

    var $sizeChart = $('.size-chart-collapsible');
    $('body').on('click touchstart', function(e) {
      if ($('.size-chart').has(e.target).length <= 0) {
        $sizeChart.removeClass('active');
      }
    });
  },
  copyProductLink: function() {
    $('body').on('click', '#fa-link', function() {
      event.preventDefault();
      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val($('#shareUrl').val()).select();
      document.execCommand('copy');
      $temp.remove();
      $('.copy-link-message').attr('role', 'alert');
      $('.copy-link-message').removeClass('d-none');
      setTimeout(function() {
        $('.copy-link-message').addClass('d-none');
      }, 3000);
    });
  }
};
